import { connect } from 'react-redux';

import { deleteById, Entities, fetchAll, getEntities, patch, search } from 'src/common';
import { addNotification } from 'src/actions/notifications';
import CustomerAdministration from 'src/components/administration/customer/customer-administration';
import { getOwnCompany } from 'src/selectors/bus-companies';
import { fetchOwnedBookingIntegrations } from 'src/actions/integrations';

const mapStateToProps = state => {
    return {
        busCompanies: getEntities(state, Entities.BUS_COMPANY),
        customers: getEntities(state, Entities.CUSTOMER, state.selectedCompany),
        customerGroups: getEntities(state, Entities.CUSTOMER_GROUP),
        selectedCompany: state.selectedCompany,
        busCompany: getOwnCompany(state),
        integration: getEntities(state, Entities.BOOKING_INTEGRATION),
    };
};

const CustomerAdministrationContainer = connect(mapStateToProps, {
    search,
    patch,
    deleteById,
    addNotification,
    fetchAll,
    fetchOwnedBookingIntegrations,
})(CustomerAdministration);

export default CustomerAdministrationContainer;
